/* ============================================================
   qua.domains — Study 2 interactions + elevation craft
   Self-contained (does not depend on qua.js).
   ============================================================ */
(function () {
  var page = document.querySelector('.page');
  if (!page) return;
  var docEl = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function disarm(){ docEl.classList.add('cx-disarm'); }

  /* hero entrance: play the clip/fade groups (no-op if not armed) */
  function arm(){ page.classList.add('cx-ready'); }
  requestAnimationFrame(function () { requestAnimationFrame(arm); });
  setTimeout(arm, 500);

  /* ROBUST VISIBILITY GUARANTEE
     The entrance depends on a CSS transition carrying elements from a hidden
     pre-state to visible. Some embeds freeze transitions (and rAF) entirely, which
     would trap content at opacity:0. So:
     1) Probe whether a transition actually ADVANCES; if not, pin everything visible.
     2) Backstop: on load + after settle, if the hero copy still isn't at opacity:1,
        pin it. This only triggers in a frozen runtime, so real browsers keep their
        entrance + scroll-reveal animations. */
  if (reduce) {
    disarm();
  } else {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:1;transition:opacity .15s linear;pointer-events:none';
    document.body.appendChild(probe);
    probe.offsetHeight;                 // force reflow so the next change transitions
    probe.style.opacity = '0';
    setTimeout(function () {
      var v = parseFloat(getComputedStyle(probe).opacity);
      if (probe.parentNode) probe.parentNode.removeChild(probe);
      if (isNaN(v) || v > 0.85) disarm();  // transition never advanced -> frozen runtime
    }, 90);
  }
  function ensureVisible(){
    var lead = document.querySelector('.hero__lead');
    if (lead && parseFloat(getComputedStyle(lead).opacity) < 0.99) disarm();
  }
  window.addEventListener('load', ensureVisible);
  setTimeout(ensureVisible, 1600);
  setTimeout(ensureVisible, 3200);

  /* ---------- sticky nav shrink ---------- */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('shrink', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- reveal + counters on scroll (IO-free for reliability) ---------- */
  var revEls = [].slice.call(document.querySelectorAll('.reveal'));
  var countEls = [].slice.call(document.querySelectorAll('[data-count]'));
  function check() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    revEls = revEls.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > -40) { el.classList.add('in'); return false; }
      return true;
    });
    countEls = countEls.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) { animateCount(el); return false; }
      return true;
    });
  }
  window.addEventListener('resize', check, { passive: true });
  /* setInterval engine: timers fire in embeds where scroll/IO events and rAF do not */
  check();
  var revTimer = setInterval(function () {
    check();
    if (!revEls.length && !countEls.length) clearInterval(revTimer);
  }, 120);

  /* ---------- tabs ---------- */
  var btns = [].slice.call(document.querySelectorAll('.tab-btn'));
  var panels = [].slice.call(document.querySelectorAll('.panel'));
  function selectTab(name) {
    btns.forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.tab === name)); });
    panels.forEach(function (p) { p.classList.toggle('is-open', p.dataset.tab === name); });
  }
  btns.forEach(function (b) {
    b.addEventListener('click', function () { selectTab(b.dataset.tab); });
    b.addEventListener('keydown', function (e) {
      var i = btns.indexOf(b);
      if (e.key === 'ArrowRight') { e.preventDefault(); var n = btns[(i + 1) % btns.length]; n.focus(); n.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); var p = btns[(i - 1 + btns.length) % btns.length]; p.focus(); p.click(); }
    });
  });

  /* ---------- cart bump + add-to-setup ---------- */
  var cart = document.querySelector('.cart');
  var count = cart ? cart.querySelector('b') : null;
  var n = 0;
  document.querySelectorAll('.svc__add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      n++; if (count) count.textContent = n;
      if (cart) { cart.classList.remove('bump'); void cart.offsetWidth; cart.classList.add('bump'); }
      var label = btn.querySelector('span'); if (!label) return;
      var prev = label.textContent;
      label.textContent = 'Added';
      btn.style.background = '#01305d'; btn.style.color = '#fff'; btn.style.borderColor = '#01305d';
      setTimeout(function () { label.textContent = prev; btn.style.background = ''; btn.style.color = ''; btn.style.borderColor = ''; }, 1100);
    });
  });

  /* ---------- hero status panel animation ---------- */
  var rows = [].slice.call(document.querySelectorAll('.status__list li'));
  var prog = document.querySelector('.status__prog i');
  var progLabel = document.querySelector('[data-prog-label]');
  if (rows.length) {
    var step = 0;
    var building = rows.findIndex(function (r) { return r.querySelector('.st-work'); });
    function tick() {
      rows.forEach(function (r) { r.classList.remove('is-active'); });
      rows[step % rows.length].classList.add('is-active');
      var pct = Math.round((Math.min(step, rows.length - 1) + 1) / rows.length * 100);
      if (prog) prog.style.width = Math.max(30, pct) + '%';
      if (progLabel) progLabel.textContent = pct + '% ready';
      step++; if (step > rows.length) step = 0;
    }
    setInterval(tick, 1600); tick();
    if (building > -1) {
      var stateEl = rows[building].querySelector('.s-state');
      var orig = stateEl.textContent;
      setInterval(function () {
        stateEl.classList.remove('st-work'); stateEl.classList.add('st-ok'); stateEl.textContent = 'live';
        setTimeout(function () { stateEl.classList.remove('st-ok'); stateEl.classList.add('st-work'); stateEl.textContent = orig; }, 2600);
      }, 5200);
    }
  }

  /* ---------- animated counters (triggered by check() on scroll) ---------- */
  function animateCount(el) {
    if (el.__counted) return; el.__counted = true;
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var finalTxt = dec ? target.toFixed(dec) : Math.round(target).toLocaleString('en-US');
    /* reduced motion or frozen-rAF embed: show the final value, don't animate */
    if (reduce || document.documentElement.classList.contains('cx-disarm')) { el.firstChild.nodeValue = finalTxt; return; }
    var dur = 1500, t0 = performance.now();
    function frame(now) {
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);          // easeOutCubic
      var val = target * e;
      el.firstChild.nodeValue = dec ? val.toFixed(dec) : Math.round(val).toLocaleString('en-US');
      if (p < 1) requestAnimationFrame(frame);
      else el.firstChild.nodeValue = finalTxt;
    }
    requestAnimationFrame(frame);
  }

  /* ---------- smooth anchor scroll ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---------- fine-pointer only: cursor ring + magnetic ---------- */
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (fine && !reduce) {
    var ring = document.createElement('div');
    ring.className = 'cx-ring';
    document.body.appendChild(ring);
    var rx = innerWidth / 2, ry = innerHeight / 2, tx = rx, ty = ry, shown = false;
    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!shown) { shown = true; ring.classList.add('on'); }
    }, { passive: true });
    window.addEventListener('pointerout', function (e) { if (!e.relatedTarget) ring.classList.remove('on'); });
    (function loop() {
      rx += (tx - rx) * 0.18; ry += (ty - ry) * 0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
      requestAnimationFrame(loop);
    })();
    var grow = 'a, button, .svc, .res, .fbox, .tab-btn, [data-magnetic]';
    document.addEventListener('pointerover', function (e) { if (e.target.closest(grow)) ring.classList.add('grow'); });
    document.addEventListener('pointerout', function (e) { if (e.target.closest(grow)) ring.classList.remove('grow'); });

    /* magnetic pull */
    [].slice.call(document.querySelectorAll('[data-magnetic]')).forEach(function (el) {
      var s = parseFloat(el.getAttribute('data-magnetic')) || 0.3;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + (mx * s) + 'px,' + (my * s) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }
})();
